import React from 'react';
import PropTypes from 'prop-types';
import { JobCard } from 'module-tsl-ui-jobs-card';
import { SortJobs } from '../SortJobs';
import JobLoading from './JobLoading';
import { Contextual } from '../Contextual';
import PaginationContainer from './PaginationContainer';
import SaveSearchBtnContainer from '../SaveSearchBtn/SaveSearchBtnContainer';

const createAdDiv = () => ({ __html: '<div class="margin-bottom-sm" data-x-marketing-slot="Job search card slot"></div>'});

const Jobs = ({ jobs, isMobile, leaderboard,
  error, loading, i18n, suffix, totalJobs, metadata, searchType, templatesByOrg, employerId, primaryColor, secondaryColor, noAds }) => {

  const hasWindow = typeof window !== 'undefined';
  const isEmbed = searchType === 'embed';

  let { cardStyle, forceLogo } = templatesByOrg[employerId] || {};
  if (primaryColor || secondaryColor) {
    cardStyle = 'silver';
    forceLogo = true;
  }

  const jobsList = jobs.map((job, idx) => {
    if (cardStyle) job.cardStyle = cardStyle;

    const newJobPricingActive = true;

    if (newJobPricingActive) {
      job.cardStyle = job.cardStyle === 'sponsored-job' ? 'sponsored-job' : 'bronze';
      job.package = 'bronze';

      forceLogo = true;
    }

    return (<div key={`${job.jobId}${job.cardStyle}`} className="margin-bottom-sm">
      {idx === 2 && !isMobile && !isEmbed && !!leaderboard && !noAds && leaderboard.map((_leaderboard, i) =>
        <div key={i} className="t-search-mpu l-advert" style={{ width: '100%' }}>
          <div className="t-leaderboard">
          </div>
        </div>
      )}
      {idx === 4 &&
        <div dangerouslySetInnerHTML={ createAdDiv() } />
      }
      <JobCard
        target={isEmbed ? '_blank' : '_self' }
        position={idx}
        {...job}
        isMobile={isMobile}
        i18n={i18n}
        forceLogo={forceLogo}
        useLogoPlaceholder={newJobPricingActive}
        forceSalaryDescription={newJobPricingActive}
        forceJobShortDescription={newJobPricingActive}
        lowApplicationCount={job.flag && job.flag.isEarlyApplicantFlag}
        logoWidth={isMobile ? '35' :'120'}
        logoHeight={isMobile ? '36.86' :'60'}
      />
    </div>);
  });
  return (
    <div className="job-results-cols clearfix">  
      <div className={(isEmbed) ? 'embed-list t-jobs-listing'  : 't-jobs-listing' }>
        <div className="l-section-primary">
          {jobs.length === 0 && !searchType && !isMobile && <SaveSearchBtnContainer />}
          {jobs.length > 0 && !error &&
            <div>
              <div className="l-inline-container padding-bottom-md margin-bottom-sm">
                <div className="l-vcenter l-vcenter--half">
                  <span className="t-page-heading padding-right-md">
                    {metadata.pagination.currentPageRange}
                    <span className="t-job-count">{loading ? <i className="icon icon-spinner icon-blue icon-spin icon-sm" /> : totalJobs}</span>&nbsp;
                      {suffix}
                  </span>
                  {!searchType && !isMobile && <SaveSearchBtnContainer />}
                </div>
                <div className="l-vcenter l-vcenter--half text-right">
                  <SortJobs />
                </div>
              </div>
              <section>
                <div className="js-list is-active">
                  {loading ? <JobLoading /> : jobsList}
                </div>
              </section>
              <PaginationContainer />
            </div>
          }
          {jobs.length === 0 && !error && <div className="no-results t-no-results text-center margin-lg">No results</div>}
          {error && <div className="no-results t-no-results text-center margin-lg">Error loading jobs</div>}
        </div>
      </div>
      <div className="job-results-right hidden-xs">
        {
          !isMobile && !isEmbed &&
            <div>
              <div className="t-search-mpu l-advert-mpu">
                <div className="t-doublempu">
                {hasWindow && <Contextual />}
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

Jobs.propTypes = {
  jobs: PropTypes.array,
  totalJobs: PropTypes.number,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  suffix: PropTypes.string,
  url: PropTypes.string,
  metadata: PropTypes.object,
  leaderboard: PropTypes.array,
  units: PropTypes.string,
  displayLocation: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  i18n: PropTypes.object
};

Jobs.defaultProps = {
  jobs: [],
  metadata: {
    pagination: {}
  },
  isMobile: false,
  loading: false,
  error: false,
  i18n: {
    country: 'gb'
  }
};

export default Jobs;
